<template>
  <div class="home-page">
    <!-- Banner Slider -->
    <PageBanner
      :images="bannerImages"
      :auto-play-interval="5000"
      :show-indicators="true"
      :show-navigation="true"
    />
    <!-- Products Section -->
    <ProductsSection :products="products" />
    <RecommendedProducts />
    <RecommendVideo />
    <RecommendedArticles />
    <RecommendedNews />
  </div>
</template>

<script setup>
import PageBanner from "@/components/common/PageBanner.vue";
import ProductsSection from "@/components/common/ProductsSection.vue";
import { ref, watch } from "vue";
import gql from "graphql-tag";
import { useQuery } from "@vue/apollo-composable";
import RecommendedProducts from "@/components/common/RecommendedProducts.vue";
import RecommendedArticles from "@/components/common/RecommendedArticles.vue";
import RecommendedNews from "@/components/common/RecommendedNews.vue";
import RecommendVideo from "@/components/common/RecommendVideo.vue";

// เพิ่ม Query HomepageBanner นี้
const GET_BANNERS = gql`
  query GetPageBanners($slug: String!) {
    HomepageBanner_pages(where: { page_slug: { _eq: $slug } }) {
      id
      title
      banners(
        where: { is_active: { _eq: true } }
        order_by: { sort_order: asc }
      ) {
        id
        image_url
        title
        description
      }
    }
  }
`;

// Banner Images
// เพิ่ม Query execution
const { result: bannerResult } = useQuery(
  GET_BANNERS,
  { slug: "home" }, // 👈 page_slug ของหน้านี้
  { fetchPolicy: "network-only" }
);

// เปลี่ยน bannerImages จาก ref hardcode เป็น ref ว่างๆ
const bannerImages = ref([]);

// เพิ่ม watch ดึงข้อมูล banner
watch(
  () => bannerResult.value?.HomepageBanner_pages,
  (newData) => {
    if (newData && newData.length > 0) {
      const rawBanners = newData[0].banners;
      bannerImages.value = rawBanners.map((banner) => ({
        url: banner.image_url,
        alt: banner.title || "Page Banner",
        title: banner.title || "",
        description: banner.description || "",
      }));
    }
  },
  { immediate: true }
);
</script>

<style scoped>
.home-page {
  min-height: 100vh;
  background-color: #f5f8fa;
  overflow-x: hidden;
}
</style>